import { Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { colors } from 'styles/theme/colors';

type CloseButtonProps = {
    closeMenu: () => void;
};

export function MegaMenuCloseButton({ closeMenu }:CloseButtonProps) {
    return (
        <Box sx={{ position: 'absolute', top: 24, right: 0 }}>
            <IconButton onClick={closeMenu} sx={{ padding: 0 }}>
                <CloseIcon sx={{ color: colors.black }} />
            </IconButton>
        </Box>
    );
}
